module.exports = __webpack_public_path__ + "static/img/Curo-dis95-logo-1.dd398531.svg";